<template>
  <div
    class="background-overlay d-flex justify-center align-center"
  >
    <img
      :src="require(`@/assets/Naccc-loader.gif`)"
      width="100"
      height="100"
    />
  </div>
</template>

<style lang="scss">
.background-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: calc(100vh - 153px);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 201;
}

.center-loader {
  position: absolute;
  top: calc(50% - 16px);
  left: calc(50% - 16px);
}
</style>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'BackgroundOverlay',
})
</script>
